/**
 * FeedbackLogic - Service functions for the contact / feedback form
 */

import { apiCall } from '@/util/api';
import type { Feedback } from './types';
import { validateFeedback } from './schema';

export const FeedbackLogic = {
  /**
   * Submit feedback to the backend (POST /api/feedback). Throws an Error
   * carrying the server's message (or a generic fallback) on any non-2xx
   * response.
   */
  async submitFeedback(data: Feedback): Promise<void> {
    const payload = validateFeedback(data);

    const response = await apiCall('/api/feedback', {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let message = 'Could not send your message. Please try again.';
      try {
        const body = await response.json();
        if (body?.error) {
          message = body.error;
        }
      } catch {
        // Non-JSON error body — keep the generic message.
      }
      throw new Error(message);
    }
  },
};
